<template>
  <card :card-title="$t('homepage.txt005')" title-image="chart" v-loading="loading">
    <template #ope>
      <el-date-picker
        class="operation-item"
        v-model="year"
        type="year"
        :placeholder="$t('homepage.txt007')"
        :clearable="false"
        @change="getData"
        value-format="yyyy"
      >
      </el-date-picker>
    </template>
    <div class="chart" id="expenseChart"></div>
  </card>
</template>

<script>
import Card from './Card';
import { validatenull } from "@/util/validate";
import { getCloudStatisticByProjectInBM, getCloudStatisticByProjectInGR } from "@/api/home/home";
import {mapGetters} from "vuex";

export default {
    name: "ExpenseDistribution",
    components: {
      Card
    },
    mounted() {
      this.$nextTick(() => {
        this.initChart()
      })
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    },
    data() {
      return {
        loading: false,
        year: new Date().getFullYear().toString(),
        chart: null,
        chartData: []
      }
    },
    methods: {
      initChart() {
        const chartDom = document.getElementById('expenseChart');
        this.chart = this.$echarts.init(chartDom);
        this.getData()
      },
      getData() {
        if (validatenull(this.year)) {
          return;
        }
        this.loading = true
        let params = {
          type: 'ajax',
          startDate: `${ this.year }-01-01`,
          endDate: `${ this.year }-12-31`
        }
        if (!validatenull(this.userInfo.optOrgScale)) {
          params.deptId = this.userInfo.optOrgScale.map(item => item.id).join(",");
          getCloudStatisticByProjectInBM(params)
            .then(res => {
              this.loading = false
              this.chartData = res.data.data
              this.setOptions(res.data.data)
            })
            .catch(() => {
              this.loading = false
            })
        }else{
          getCloudStatisticByProjectInGR(params)
            .then(res => {
              this.loading = false
              this.chartData = res.data.data
              this.setOptions(res.data.data)
            })
            .catch(() => {
              this.loading = false
            })
        }
      },
      setOptions(chartData) {
        const option = {
          tooltip: {
            trigger: 'item',
            enterable: true
          },
          title: {
            text: this.$t('homepage.txt008'), //报销费用类型统计，单位（元）
            left: '50%',
            top: '0',
            textAlign: 'center'
          },
          series: [
            {
              type: 'pie',
              radius: '45%',
              center: ['50%', '50%'],
              selectedMode: 'single',
              label: {
                formatter: '{a|{b}}\n{hr|}\n  {per|'+this.$t('homepage.txt009')+'  : {c} }  \n{hr|}\n {per|'+this.$t('homepage.txt010')+' : {d}%}  ',
                backgroundColor: '#F2F6FC',
                borderColor: '#DCDFE6',
                borderWidth: 1,
                borderRadius: 3,
                width: 160,
                padding: 10,
                rich: {
                  a: {
                    lineHeight: 26,
                    align: 'center',
                    fontWeight: 'bold',
                    fontSize: 14
                  },
                  hr: {
                    width: '100%',
                    height: 0
                  },
                  b: {
                    fontWeight: 'bold',
                    lineHeight: 24,
                    align: 'center'
                  },
                  per: {
                    lineHeight: 24,
                    align: 'center'
                  }
                }
              },
              itemStyle: {
                borderColor: '#fff'
              },
              avoidLabelOverlap: false,
              data: chartData,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.1)'
                }
              }
            }
          ]
        };
        this.chart.setOption(option)
      }
    },
    computed: {
      ...mapGetters(['userInfo']),
    }
  }
</script>

<style scoped>
  .chart {
    width: 100%;
    height: 100%;
  }
</style>
